const types = {
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  MARK_AS_READ: "MARK_AS_READ",
};

const actions = {
  addNotification: (message) => ({
    type: types.ADD_NOTIFICATION,
    payload: message,
  }),
  markAsRead: (message) => ({
    type: types.MARK_AS_READ,
    payload: message,
  }),
};

export { types };
export default actions;
